import mutationQuery from 'graphql/mutations/purchases/ShortageGenerationMutation.graphql';
import fragment from 'graphql/fragments/purchases/ShortageSingleGenerationFragment.graphql';
import { PurchaseRequirement } from 'graphql/entities';

const PurchaseOrderShortageGenerationCriteria = {
  type: 'PurchaseOrderShortageGenerationCriteria',
  title: 'Shortage Generation Criteria',
  formTitle: 'Shortage Generation Criteria',
  formUrl: '/Purchasing/ShortageGeneration/Criteria/',
  workspaceUrl: PurchaseRequirement.workspaceUrl,
  update: mutationQuery,
  fragment,
  screenReference: 'SHORTAGES_GENERATION',
  operations: 0, //Not an entity, just a generation form.
};

export default PurchaseOrderShortageGenerationCriteria;
